<!-- TODO: Change colour to use CSS variable once the library allows this again -->
<ng-progress
  id="loader"
  [color]="'hsla(180, 39%, 46%, 1)'"
  [thick]="false"
  [trickleSpeed]="1"
  [spinner]="true"
  [meteor]="false"
></ng-progress>
